module.exports = __webpack_public_path__ + "static/media/1004415.8174438e.jpg";